<template>
  <div>
    <div class="page-amounts">
      <nav aria-label="...">
        <ul class="pagination pagination-md">
          <li class="page-item" :class="{ selected: amount === 3 }">
            <a @click="setAmountPerPAge(3)" class="page-link paginate">3</a>
          </li>
          <li class="page-item" :class="{ selected: amount === 10 }">
            <a @click="setAmountPerPAge(10)" class="page-link paginate">10</a>
          </li>
          <li class="page-item" :class="{ selected: amount === 50 }">
            <a @click="setAmountPerPAge(50)" class="page-link paginate">50</a>
          </li>
          <li class="page-item" :class="{ selected: amount === 100 }">
            <a @click="setAmountPerPAge(100)" class="page-link paginate">100</a>
          </li>
          <li class="page-item" :class="{ selected: amount === 150 }">
            <a @click="setAmountPerPAge(150)" class="page-link paginate">150</a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="paginator-info-top m-2">
      <span class="m--font-gray" v-if="from"
        >Exibindo itens de {{ from }} a {{ to }}, de um total de {{ total }}.</span
      >
      <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PaginatorTop',
  data() {
    return {};
  },
  props: {
    amount: {
      type: [Number, String],
    },
    from: {
      type: Number,
    },
    to: {
      type: Number,
    },
    total: {
      type: Number,
    },
  },
  methods: {
    setAmountPerPAge(amount) {
      this.$emit('setAmountPerPage', amount);
    },
  },
};
</script>
